import React from 'react';

// DEPENDENCIES
import { compose } from 'redux';

// GLOBAL VARIABLES
import { INTERFACE, USER } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { checkRole, makePath } from 'functions.js';

// GLOBAL HELPERS
import { sessionTimer } from 'helpers/sessionTimer';

// ROUTER COMPONENTS
import { Navigate, Route, Routes } from "react-router-dom";

// GLOBAL COMPONENTS
import Modal from 'core/tools/modal/Modal';
import Wrapper from 'parts/wrapper/Wrapper';

// ROUTES
import AccountingTasks from './routes/AccountingTasks';
import AMFinance from './routes/AMFinance';
import DailySales from './routes/dailySales/DailySales';
import Dashboard from './routes/Dashboard';
import DealTasks from './routes/DealTasks';
import DeliveryLog from './routes/DeliveryLog';
import EmailSettings from './routes/EmailSettings';
import Fallout from './routes/Fallout';
import Forms from './routes/Forms';
import Sales from './routes/Sales';
import Inventory from './routes/Inventory';
import Notifications from './routes/Notifications';
import Order from './routes/Order';
import Profile from './routes/Profile';
import Settings from './routes/Settings';
import Search from './routes/Search';
import ChangePassword from './routes/ChangePassword';
import Dev from '../dev/Dev';
import ViewFile from './routes/viewFile/ViewFile';

// MAIN COMPONENT
const Interface = compose(
  sessionTimer
)(() => (
  <Routes>
    <Route
      path={makePath('dev') + '*'}
      element={<Dev />}
    />
    <Route
      path={makePath(INTERFACE.viewFile)}
      element={<ViewFile />}
    />
    <Route path="*" element={(
      <Wrapper>
        <Routes>
          {/* MAIN MENU */}
          {checkRole(['dslAdmin', 'salesManager', 'salesManagerPlus', 'financeManager']) &&
            <Route
              path={makePath(INTERFACE.dashboard) + '*'}
              element={<Dashboard />}
            />
          }
          <Route
            path={makePath(INTERFACE.forms)}
            element={<Forms />}
          />
          {(checkRole(['dslAdmin', 'salesManager', 'salesManagerPlus', 'financeManager']) && [
            <Route
              path={makePath(INTERFACE.dailySales)}
              element={<DailySales />}
            />,
            <Route
              path={makePath(INTERFACE.amFinance) + '*'}
              element={<AMFinance />}
            />,
            <Route
              path={makePath(INTERFACE.fallout) + '*'}
              element={<Fallout />}
            />,
            <Route
              path={makePath(INTERFACE.order) + '*'}
              element={<Order />}
            />,
            <Route
              path={makePath(INTERFACE.deliveryLog) + '*'}
              element={<DeliveryLog />}
            />,
            <Route
              path={makePath(INTERFACE.sales) + '*'}
              element={<Sales />}
            />,
            <Route
              path={makePath(INTERFACE.accountingTasks) + '*'}
              element={<AccountingTasks />}
            />,
            <Route
              path={makePath(INTERFACE.dealTasks)}
              element={<DealTasks />}
            />
          ])}
          <Route
            path={makePath(INTERFACE.inventory) + '*'}
            element={<Inventory />}
          />
          {checkRole(['dslAdmin', 'salesManager', 'salesManagerPlus']) &&
            <Route
              path={makePath(INTERFACE.settings) + '*'}
              element={<Settings />}
            />
          }
          {/* USER */}
          <Route
            path={makePath(USER.profile)}
            element={<Profile />}
          />
          <Route
            path={makePath(USER.changePassword)}
            element={<ChangePassword />}
          />
          <Route
            path={makePath(USER.emailSettings)}
            element={<EmailSettings />}
          />
          {/* OTHER */}
          <Route
            path={makePath(INTERFACE.notifications)}
            element={<Notifications />}
          />
          <Route
            path={makePath(INTERFACE.search)}
            element={<Search />}
          />
          {/* DEFAULT */}
          <Route path="*" element={<Navigate to={checkRole(['inventoryManager']) ? makePath(INTERFACE.inventory) : makePath(INTERFACE.dailySales)} replace />} />
        </Routes>
        <Modal.Router />
      </Wrapper>
    )} />
  </Routes>
))

// EXPORT
export default Interface;
